import { localPlayerContainer } from "../localplayer/LocalPlayerContainer";
import { mainScene } from "../rendering/mainScene";
import { LoadMeshMessage, MeshLoadedMessage } from "../../messages/rendering/RendererMessages";
const GEOMETY_MESH_FILE_NAME = "meshes/gesture.view";
var SUBMESH_NAMES;
(function (SUBMESH_NAMES) {
    SUBMESH_NAMES["value"] = "value";
    SUBMESH_NAMES["compass"] = "compass";
    SUBMESH_NAMES["needle"] = "needle";
    SUBMESH_NAMES["threshold"] = "threshold";
})(SUBMESH_NAMES || (SUBMESH_NAMES = {}));
export class TwoHandedGestureView {
    init(connection) {
        connection
            .askByMessageType(new LoadMeshMessage(GEOMETY_MESH_FILE_NAME), MeshLoadedMessage)
            .then((message) => {
            const geometry = message.mesh.clone();
            geometry.matrixAutoUpdate = false;
            const value = geometry.getObjectByName(SUBMESH_NAMES.value);
            const compass = geometry.getObjectByName(SUBMESH_NAMES.compass);
            const needle = geometry.getObjectByName(SUBMESH_NAMES.needle);
            const threshold = geometry.getObjectByName(SUBMESH_NAMES.threshold);
            if (!value || !compass || !needle || !threshold) {
                console.error(`[TwoHandedGestureView] --- Mesh ${GEOMETY_MESH_FILE_NAME} doesn't have the required submeshes`);
            }
            else {
                this.data = { geometry, value, compass, needle, threshold };
            }
        })
            .catch(() => {
            console.error(`[TwoHandedGestureView] --- Failed on load mesh ${GEOMETY_MESH_FILE_NAME}`);
        });
    }
    reset() {
        this.data && this.data.geometry.parent && mainScene.remove(this.data.geometry);
    }
    onBeginScaling(startAngle) {
        if (this.data) {
            mainScene.add(this.data.geometry);
            this.data.threshold.rotation.y = startAngle;
            this.data.threshold.updateMatrix();
            this.data.threshold.visible = true;
            this.data.compass.visible = false;
            this.data.needle.visible = false;
            this.data.value.visible = true;
        }
    }
    onBeginRotation() {
        if (this.data) {
            mainScene.add(this.data.geometry);
            this.data.threshold.visible = false;
            this.data.compass.visible = true;
            this.data.needle.visible = true;
            this.data.value.visible = false;
        }
    }
    update(p1, p2, angle, scale) {
        if (!this.data)
            return;
        if (scale) {
            this.data.value.rotation.y = angle;
            this.data.value.scale.x = scale;
            this.data.value.updateMatrix();
        }
        else {
            localPlayerContainer.getOrientation(this.data.compass.quaternion);
            this.data.compass.quaternion.invert();
            this.data.compass.updateMatrix();
        }
        // set geomety postition to the center of p1 and p2
        this.data.geometry.position.addVectors(p1, p2).multiplyScalar(0.5);
        // apply platform transformation
        localPlayerContainer.transformPointFromPlatformToWorldCoordinates(this.data.geometry.position);
        localPlayerContainer.getOrientation(this.data.geometry.quaternion);
        this.data.geometry.scale.setScalar(localPlayerContainer.getPlatformScale());
        this.data.geometry.updateMatrix();
        this.data.geometry.updateMatrixWorld(true);
    }
}
